// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminEventSearchResponse

import { hydrateAdminEvent, type AdminEvent, type AdminEventApiResponse } from './adminEvent.gen';

export type AdminEventSearchApiResponse = {
	items: AdminEventApiResponse[];
};

export type AdminEventSearch = {
	items: AdminEvent[];
};

export function hydrateAdminEventSearch(data: AdminEventSearchApiResponse): AdminEventSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminEvent),
	};
}